import { CANCEL_DIALOG, INIT_DIALOG } from './dialog-action-type.tsx';

export const cancelDialog = () => ({
	type: CANCEL_DIALOG,
});

export const initDialog = () => ({
	type: INIT_DIALOG,
});
